import { MIME_TYPE_IMAGE_PREFIX } from 'www/constants/fileTypes'

export default function checkIsImage(file: File) {
  return file.type.indexOf(MIME_TYPE_IMAGE_PREFIX) !== -1
}
